import { render, staticRenderFns } from "./ArrobaMedellinArrobitaNoDataProfile.html?vue&type=template&id=4303bfe4&scoped=true&"
import script from "./ArrobaMedellinArrobitaNoDataProfile.vue?vue&type=script&lang=js&"
export * from "./ArrobaMedellinArrobitaNoDataProfile.vue?vue&type=script&lang=js&"
import style0 from "./ArrobaMedellinArrobitaNoDataProfile.scss?vue&type=style&index=0&id=4303bfe4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4303bfe4",
  null
  
)

export default component.exports